<template>
  <b-row>
    <b-col class="contact">
      <div class="contact__box">
        <div class="contact__info" v-html="sanitizedText"></div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    text: String,
  },
  computed: {
    sanitizedText() {
      return this.text ? DOMPurify.sanitize(marked(this.text)) : ''
    }
  }
}
</script>

<style scoped>
.contact {
  margin-bottom: 200px !important;
}

.contact__box {
  background-color: rgba(56, 97, 136, 1);
  padding: 1.5rem;
  text-align: center;
}

.contact__info p {
  font-size: 1.25rem;
  font-weight: 500 !important;
  margin: 0;
  padding: 0;
  color: #fff !important;
}
</style>
